module.exports = {
    category: '/api/v1' + window.localeWithLanguage + '/category',
    checkout: {
        countries: '/checkout/api/billingCountries?siteCode=' + window.siteCode + '&pushSite=' + window.siteId,
        states: '/checkout/api/billingStates?siteCode=' + window.siteCode + '&pushSite=' + window.siteId
    },
    config: '/config/site?siteCode=' + window.siteCode + '&pushSite=' + window.siteId,
    customer: {
        base: '/customer',
        subscription: '/customer/current/subscriptions/email'
    },
    email: '/api/tibco/v1/email',
    inventory: '/api/fdis/v1/pools',
    i18n: {
        base: '/config/sites',
        currencies: '/currencies',
        languages: '/languages'
    },
    login: '/login',
    misl: {
        stores: '/api/misl/v1/stores/search'
    },
    orders: {
        base: '/orders/current',
        cartCount: '/orders/current/getTotalCartCount?siteCode=' + window.siteCode + '&pushSite=' + window.siteId,
        items: '/orders/current/items?siteCode=' + window.siteCode + '&pushSite=' + window.siteId
    },
    profile: '/api/profile/v0',
    product: '/orchestration/features/shop/quickshop',
    registry: '/api/registry/v1',
    rootCats: '/api/v1' + window.localeWithLanguage + '/rootCats',
    token: '/api/token/v0'
};
